"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COMPONENT_NAME = void 0;
var _classNameGenerator = require("../../theming/classNameGenerator");
var COMPONENT_NAME = exports.COMPONENT_NAME = 'WindowDialog';
var CLASSNAME_WINDOW_DIALOG = (0, _classNameGenerator.generateComponentClassNames)({
  component: COMPONENT_NAME,
  children: ['Header', {
    component: 'Header',
    children: ['Close']
  }, 'Title', 'Content', 'Actions']
});
var _default = exports["default"] = CLASSNAME_WINDOW_DIALOG;